// 주로 백엔드에 보낼 때 사용하는 Flag 변수
export const UNQUALIFIED = 1
export const BASIC_ROOKIE = 2
export const ROOKIE = 3
export const BASIC_SEMI = 4
export const SEMI = 5
export const BASIC_TOUR = 6
export const TOUR = 7

// 주로 백엔드에서 온 값을 출력할 때 사용하는 Object
export const convertProGradeAsName = {
    "1": "없음",
    "2": "Basic Rookie",
    "3": "Rookie",
    "4": "Basic Semi",
    "5": "Semi",
    "6": "Basic Tour",
    "7": "Tour",
}